<div class="container-info-pay">
    <div class="logo-city">
        <img fallimg src="assets/img/citylok_logo.png" alt="Citylok logo">
    </div>
    <!-- <p class="title-confirm">Gracias por confiar en Citylok</p> -->
    <p class="info-confirm">Tu compra se ha realizado correctamente.</p>
</div>